import {
  dateFormatter,
  formatURLDate,
  isAgentLoggedIn,
  isValidDate,
} from '../../../common/utils/browserUtils';
import { getRoomFromParams } from '../../../common/utils/formattingUtils';
import { getMergedFilters } from '../../helpers/filtersUtils';
import { getAllUrlParams, getReqDataSsr, validateTheme } from '../../helpers/utils';
import {
  SET_LISTING_FILTERS,
  SET_LISTING_FILTERS_IS_LOADING,
  SET_LISTING_METADATA,
  SET_LISTING_METADATA_IS_LOADING,
} from '../constants/listingMetaDataConstants';
import { getListingMetaData } from '../services/listingMetaDataService';

export const getListingMetaDataAction = requestParam => async (dispatch, getState) => {
  // eslint-disable-next-line no-undef
  const queryParams = ssr.isOnClient ? getAllUrlParams() : getReqDataSsr(requestParam);
  const { metadata } = getState();
  const searchText = isAgentLoggedIn() ? queryParams?.searchText : '';
  const params = {
    queryParams,
    departureCity: queryParams.depCity || 'New Delhi',
    destinationCity: queryParams.dest,
    filterSorterParam: true,
    filteredFiltersRequired: true,
    apiVersion: 'v21',
    searchText,
  };
  if (params?.queryParams?.themes) {
    params.queryParams.themes = validateTheme({
      metaFilterList: metadata?.initialFilters,
      themeValue: queryParams?.themes,
    });
  }

  if (queryParams.packageIds) {
    params.packageIds = queryParams.packageIds.split(',');
  }

  if (queryParams.campaign) {
    params.campaign = queryParams.campaign;
  }

  if (queryParams?.rooms) {
    params.rooms = getRoomFromParams(queryParams?.rooms);
  }

  if (isValidDate(queryParams?.dateSearched)) {
    params.packageDate = dateFormatter(formatURLDate(queryParams?.dateSearched), 'YYYY-MM-DD');
  }

  dispatch({
    type: SET_LISTING_METADATA_IS_LOADING,
    payload: true,
  });
  try {
    const response = await getListingMetaData(params);
    if (response.data.success) {
      const {
        destinationMeta,
        headerDetail,
        listingFilters,
        listingSorters,
        noMorePackages,
        numFound,
        pageSize,
        listingRedirection,
        details,
      } = response.data;

      const mergedFilters = getMergedFilters(listingFilters, metadata?.initialFilters);

      dispatch({
        type: SET_LISTING_METADATA,
        payload: {
          destinationMeta,
          headerDetail,
          listingFilters: mergedFilters,
          listingSorters,
          noMorePackages,
          numFound,
          pageSize,
          listingRedirection,
          branch: details?.[0]?.branch || 'DOM',
          departureDate: new Date(params.packageDate).getTime(),
          tags: params?.queryParams?.themes,
        },
      });
    }

    dispatch({
      type: SET_LISTING_METADATA_IS_LOADING,
      payload: false,
    });
  } catch (e) {
    dispatch({
      type: SET_LISTING_METADATA_IS_LOADING,
      payload: false,
    });
  }
};
export const getListingFiltersAction = requestParam => async dispatch => {
  // eslint-disable-next-line no-undef
  const queryParams = ssr.isOnClient ? getAllUrlParams() : getReqDataSsr(requestParam);
  const params = {
    departureCity: queryParams.depCity || 'New Delhi',
    destinationCity: queryParams.dest,
    filterSorterParam: true,
    filteredFiltersRequired: true,
    apiVersion: 'v21',
  };

  if (queryParams.packageIds) {
    params.packageIds = queryParams.packageIds.split(',');
  }

  if (queryParams.campaign) {
    params.campaign = queryParams.campaign;
  }

  if (queryParams?.rooms) {
    params.rooms = getRoomFromParams(queryParams?.rooms);
  }

  if (isValidDate(queryParams?.dateSearched)) {
    params.packageDate = dateFormatter(formatURLDate(queryParams?.dateSearched), 'YYYY-MM-DD');
  }

  dispatch({
    type: SET_LISTING_FILTERS_IS_LOADING,
    payload: true,
  });
  try {
    const response = await getListingMetaData(params);
    if (response.data.success) {
      const { listingFilters } = response.data;
      dispatch({
        type: SET_LISTING_FILTERS,
        payload: {
          listingFilters,
        },
      });
    }

    dispatch({
      type: SET_LISTING_FILTERS_IS_LOADING,
      payload: false,
    });
  } catch (e) {
    dispatch({
      type: SET_LISTING_FILTERS_IS_LOADING,
      payload: false,
    });
  }
};
